<template>
<v-navigation-drawer bottom color="transparent" fixed height="auto" overlay-color="secondary" overlay-opacity=".8" temporary v-bind="$attrs" v-on="$listeners">
     <v-list color="white" shaped>
          <v-list-item v-for="(i,index) in data" :key="index" :to="'vip/' +  i.route == 'accueil' ? '' : i.route" :color="(settings[0] ? settings[0].color : '#2F839D')">
               <v-list-item-content>
                    <v-list-item-title v-text="localLang == 'fr' ? i.nameFr : i.nameAr" />
               </v-list-item-content>
          </v-list-item>
     </v-list>
</v-navigation-drawer>
</template>

<script>
export default {
     name: 'HomeDrawer',

     props: {
          items: {
               type: Array,
               default: () => ({}),
          },
     },
     computed: {
         data() {
               return this.myArray2.filter(e => e.status != 0) 
          }
          
     }
}
</script>
